import React from 'react'
import PropTypes from 'prop-types'

import { Table } from '../../..'
import { DateUtils } from '../../../../utils'
import { usePageTitle } from '../../../../actions/app'

const tableDisplay = [
    {
        field: 'id',
        label: 'ID',
        props: null,
        transform: null,
        width: '50px',
    },
    {
        field: 'layer_id',
        label: 'Layer',
        props: null,
        transform: null,
        width: '70px',
    },
    {
        field: 'name',
        label: 'Name',
        props: null,
        transform: null,
        width: '300px',
    },
    {
        field: 'priority',
        label: 'Priority',
        onlyOnLG: true,
        props: null,
        transform: null,
        width: '100px',
    },
    {
        field: 'exclusive',
        label: 'Excl.',
        onlyOnLG: true,
        props: null,
        transform: (exc) => (exc ? 'Yes' : 'No'),
        width: '100px',
    },
    {
        field: 'synced',
        label: 'Sync',
        props: null,
        transform: (sync) => (sync ? 'Yes' : 'No'),
        width: '100px',
    },
    {
        field: 'date_start',
        label: 'Starting on',
        props: { align: 'center' },
        transform: (date) => (date ? DateUtils.formatUIShort(date) : 'n/a'),
        width: '120px',
    },
    {
        field: 'date_end',
        label: 'Ending on',
        props: { align: 'center' },
        transform: (date) => (date ? DateUtils.formatUIShort(date) : 'n/a'),
        width: '120px',
    },
]

const Playlists = ({ data, onChangeSearch, valueSearch }) => {
    usePageTitle('Playlists')

    return (
        <Table data={data} display={tableDisplay} keyField="id" onChangeSearch={onChangeSearch} sortable title="Playlists" valueSearch={valueSearch} />
    )
}

Playlists.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            priority: PropTypes.number,
            exclusive: PropTypes.bool,
            synced: PropTypes.bool,
        })
    ).isRequired,
    onChangeSearch: PropTypes.func.isRequired,
    valueSearch: PropTypes.string,
}

Playlists.defaultProps = {
    valueSearch: '',
}

export default Playlists
